
import React, { Component } from 'react';
import './review.css';

export class ReviewEntry extends Component {

  render() {
    return (
      <div className="ReviewEntry">
        <h5>{this.props.rating}/5</h5>
        <div>
          {this.props.review}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/review.js